module.exports = __webpack_public_path__ + "img/wb.2b0ea1f1.png";